import React, { useCallback, useEffect, useState } from "react";

import { getPartner } from "services";

import { useCancelAsyncOnUnmount, useParams } from "utils";

import { AdminHead, Col, MainPage, Row, Tabs } from "components";

import { AssignModuleCreditsToSinglePartner } from "pages/admin/partners//components/AssignModuleCreditsToSinglePartner";
import { AssignMethodCreditsToSinglePartner } from "pages/admin/partners/components/AssignMethodCreditsToSinglePartner";
import { AttachFarmers } from "pages/admin/partners/components/AttachFarmers";
import { PartnerCredits } from "pages/admin/partners/components/PartnerCredits";
import { PartnerSettings } from "pages/admin/partners/components/PartnerSettings";

export const PartnerUpdate = () => {
  const { id } = useParams();

  const [loading, setLoading] = useState(true);
  const [partner, setPartner] = useState(null);
  const [activeTab, setActiveTab] = useState("details");
  const signal = useCancelAsyncOnUnmount()();

  const loadPartner = useCallback(() => {
    setLoading(true);

    getPartner({
      id,
      signal,
    })
      .then((res) => {
        setPartner(res);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [id, signal]);

  useEffect(() => {
    loadPartner();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <MainPage loading={loading} pageName={"admin"}>
      <AdminHead
        headline={partner?.name}
        link="/partners/partners"
        tooltipText="Back to partners"
        description="Update a partner here. The hectare limit is the maximum amount of hectares to which methods can be applied, per-farm. This will override the default hectare limit for any farm which has been attached to this partner. The point price is the amount which this partner will partner will pay per kg of carbon sequestered by any farmer attached to this partner."
      />
      <Row>
        <Col>
          <Tabs
            activeKey={activeTab}
            onChange={(tab) => setActiveTab(tab)}
            size="small"
            items={[
              {
                label: "Credits",
                key: "credits",
                children: partner && !partner.disabled && <PartnerCredits partner={partner} onUpdateSuccess={() => loadPartner(id, setPartner, setLoading)} />,
                disabled: !(partner && !partner.disabled),
              },
              {
                label: "Farmers",
                key: "farmers",
                children: partner && !partner.disabled && <AttachFarmers partner={partner} onUpdateSuccess={() => loadPartner(id, setPartner, setLoading)} />,
                disabled: !(partner && !partner.disabled),
              },
              {
                label: "Partner details",
                key: "details",
                children: <PartnerSettings partner={partner} onUpdateSuccess={() => loadPartner(id, setPartner, setLoading)} />,
              },
              {
                label: "Assign Module Credits",
                key: "moduleAssignments",
                children: <AssignModuleCreditsToSinglePartner partner={partner} />,
              },
              {
                label: "Assign Method Credits",
                key: "methodAssignments",
                children: <AssignMethodCreditsToSinglePartner partner={partner} />,
              },
            ]}
          />
        </Col>
      </Row>
    </MainPage>
  );
};
